import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { IWizItemRenderer, WizEventManager } from '@wizeoo/akm-component-lib';
import { IncExcContentObj } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, INC_EXC_KIND } from '@wizeoo/akm-common-lib';
/**
 * rendu d'un élément main Include / exclude
 */
@Component({
  selector: 'incex-keypart-renderer',
  templateUrl: './incex-keypart.renderer.html',
})
export class IncExcKeyPartRenderer implements IWizItemRenderer<null, IncExcContentObj> {
  @ViewChild('tileRenderer', { read: BaseTileRenderer, static: true })
  tileRenderer: BaseTileRenderer;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: IncExcContentObj;
  public get data(): IncExcContentObj {
    return this._data;
  }
  public set data(data: IncExcContentObj) {
    this._data = data;
  }

  /** demande de suppression de l'élément */
  public delPart(): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.INC_EXC_DEL_PART, this.data));
  }

  public isFD(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.FDV;
  }

  public isChron(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.CHRO;
  }
}
